export const CHECKLIST_STATUS = {
    OK: 'ok',
    CREATED: 'created',
    ACTION_NEEDED: 'action_needed',
    WARNING: 'warning'
};
export const CHECKLIST_ITEM_KEY = {
    TAG: 'tag',
    EQUIPMENT_TYPES: 'equipment_types',
    TECHNICIANS: 'technicians',
    JOB_CUSTOM_FIELD_PREFIX: 'job_custom_field:'
};
export const PULL_STATUS = {
    RUNNING: 'running',
    COMPLETE: 'complete',
    FAILED: 'failed'
};
export const PULL_POLL_INTERVAL_MS = 5000;
export const PULL_POLL_BACKOFF_FACTOR = 2;
export const PULL_POLL_MAX_DELAY_MS = 60000;
export const FAILURE_REASONS = {
    MISSING_REQUIRED_FIELD: 'missing_required_field',
    TENANT_CLAIM_MISSING: 'tenant_claim_missing',
    TENANT_ROUTE_COLLISION: 'tenant_route_collision',
    INVALID_CREDENTIALS: 'invalid_credentials',
    APP_NOT_CONNECTED: 'app_not_connected',
    UNREACHABLE: 'unreachable',
    ALREADY_RUNNING: 'already_running'
};
export const KNOWN_FAILURE_STEPS = [
    'inspection',
    'contact',
    'technician',
    'equipment',
    'finding',
    'attachment',
    'job_field'
];
